import './index.css';
const DEFAULT_SIZE = 'medium';

export { DEFAULT_SIZE };
//# sourceMappingURL=types.js.map
